import { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Modal, Tooltip, Whisper } from "rsuite";

import { EPInput } from "../../common/controls";
import { Info } from "../../common/controls/info";
import {
  PostRole,
  UpdateRole,
  validateSystemAdminAndRecruiter,
} from "../../common/utils/api";
import { CommonConstants } from "../../common/utils/CommonConstants";
import { axiosGet, axiosPost, axiosUpdate } from "../../common/utils/helper";
import Loader from "../Loader/loader";

interface IRole {
  RoleId?: number;
  RoleName?: string;
  IsSystemAdmin?: boolean;
  IsRecruiter?: boolean;
}
interface Props {
  open: boolean;
  action?: string;
  isValidate?: boolean;
  refresher?: boolean;
  setRefresher?: any;
  singleData?: any;
  setOpen: (open: boolean) => void;
}

export default function AddRoleModal(props: Props) {
  const { open, setOpen, action, setRefresher, singleData, refresher } = props;
  // const [ProjectName, setProjectName] = useState<string>(
  //   singleData?.ProjectName ? singleData?.ProjectName : ""
  // );
  const [roleModalData, setRoleModalData] = useState<any>({
    RoleId: singleData?.RoleId,
    RoleName: singleData?.Name,
    IsRecruiter: singleData?.IsRecruiter,
    IsSystemAdmin: singleData?.IsSystemAdmin,
  });

  const [isSystemAdminExist, setIsSystemAdminExist] = useState();
  const [isRecruiterExist, setIsRecruiterExist] = useState();

  const [loading, setLoading] = useState<boolean>(false);
  const [isValidate, setIsValidate] = useState(false);
  const regexPattern =
    /^(?!\d+$)(?!.*\s{2})(?!.*\.{2})(?!.*\.\s)[a-zA-Z0-9\s.]+$/;

  let response: AxiosResponse;
  function closeModal() {
    setOpen(false);
  }

  useEffect(() => {
    axiosGet(validateSystemAdminAndRecruiter, {}, true)
      .then((res: any) => {
        setIsSystemAdminExist(
          !res.data.data.isSystemAdminExist || singleData?.IsSystemAdmin
        );
        setIsRecruiterExist(
          !res.data.data.isRecruiterExist || singleData?.IsRecruiter
        );
      })
      .catch((e) => {
        console.log("e", e);
      });
  }, []);

  function handleModalKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === "Enter" && !loading) {
      handleSubmit();
    }
  }

  function handleKeyPress(event: any) {
    if (
      (event?.target?.value?.endsWith(" ") &&
        !regexPattern.test(event?.target?.value + event?.key)) ||
      !regexPattern.test(event?.target?.value + event?.key)
    ) {
      event.preventDefault();
    }
  }

  const handleOnChange = (value: string | number | Date, name: string) => {
    let data = { ...roleModalData };
    data[name] = value;
    setRoleModalData(data);
  };

  async function handleSubmit() {
    setIsValidate(true);
    if (!roleModalData?.RoleName) {
      const message = "Field cannot be empty.";
      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (roleModalData?.RoleName?.trim().length < 2) {
      const message = "Please fill mandatory fields.";
      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      action === "Add"
        ? await postRoleName(PostRole, {
            RoleName: roleModalData?.RoleName?.trim(),
            IsRecruiter: roleModalData.IsRecruiter,
            IsSystemAdmin: roleModalData.IsSystemAdmin,
          })
        : await updateProjectName(`${UpdateRole}/${roleModalData?.RoleId}`, {
            RoleName: roleModalData?.RoleName?.trim(),
            IsRecruiter: roleModalData.IsRecruiter,
            IsSystemAdmin: roleModalData.IsSystemAdmin,
          });
      refresher ? setRefresher(false) : setRefresher(true);
      closeModal();
    }
  }

  async function postRoleName(reqUrl: string, reqBody: IRole) {
    setLoading(true);
    response = (await axiosPost(reqUrl, { reqBody }, true)) as AxiosResponse;
    if (
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      setLoading(false);
      toast.success("Role saved successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "error"
    ) {
      setLoading(false);
      toast.warning("Role already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  async function updateProjectName(reqUrl: string, reqBody: IRole) {
    response = (await axiosUpdate(reqUrl, { reqBody }, true)) as AxiosResponse;
    if (
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      toast.success("Role updated successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "error"
    ) {
      toast.warning("Role already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  return loading ? (
    <Loader />
  ) : (
    <Modal
      open={open}
      onClose={closeModal}
      className="modal-sm"
      backdrop="static"
      keyboard={false}
      onKeyDown={handleModalKeyDown}
    >
      <Modal.Header closeButton={true}>
        {action === "Edit" ? "Edit Role" : "Add Role"}
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs lg="12" className="recruiter-label">
            Role Name <span className="req">* </span>
            <Info message="Minimum 2 characters, Maximum 50 characters" />
          </Col>
          <Col xs lg="12" className="recruiter-label">
            <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
              <EPInput
                onKeyPress={handleKeyPress}
                label="Role"
                minlength={2}
                maxlength={50}
                style={{ width: 100 }}
                onChange={(val: string) => handleOnChange(val, "RoleName")}
                value={roleModalData?.RoleName}
                isValidate={isValidate}
              />
            </Whisper>
          </Col>
        </Row>
        <Row>
          <div className="form-group radio-border mt-0 pt-0">
            <div className="align-top">
              {isSystemAdminExist && (
                <Form.Check
                  inline
                  label="Work as system admin"
                  name="Work as system admin"
                  type="radio"
                  onChange={(e) =>
                    setRoleModalData(() => ({
                      ...roleModalData,
                      IsSystemAdmin: e.target.checked,
                      IsRecruiter: false,
                    }))
                  }
                  checked={roleModalData.IsSystemAdmin}
                />
              )}
              {isRecruiterExist && (
                <Form.Check
                  inline
                  label="Work as recruiter"
                  name="Work as recruiter"
                  type="radio"
                  onChange={(e) =>
                    setRoleModalData(() => ({
                      ...roleModalData,
                      IsRecruiter: e.target.checked,
                      IsSystemAdmin: false,
                    }))
                  }
                  checked={roleModalData.IsRecruiter}
                />
              )}
              {(isSystemAdminExist || isRecruiterExist) && (
                <Form.Check
                  inline
                  label="None"
                  name="None"
                  type="radio"
                  onChange={(e) =>
                    setRoleModalData(() => ({
                      ...roleModalData,
                      IsSystemAdmin: false,
                      IsRecruiter: false,
                    }))
                  }
                  checked={
                    !roleModalData.IsSystemAdmin && !roleModalData.IsRecruiter
                  }
                />
              )}
            </div>
          </div>
        </Row>
      </Modal.Body>
      <Modal.Footer className="pt-3">
        <Row>
          <Col xs lg>
            <Button
              type="button"
              onClick={() => handleSubmit()}
              className="btn btn-primary"
            >
              {action === "Edit" ? "Update" : "Save"}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}
